import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { AppState } from '../../../core/store';
import { selectTelaVisibility } from '../../../core/store/ui/ui.selectors';
import { Icon } from '../icon/icon';

@Component({
  selector: 'app-tela-chat',
  standalone: true,
  imports: [RouterLink, Icon],
  templateUrl: './tela-chat.html',
  styleUrl: './tela-chat.scss',
})
export class TelaChat {
  private store = inject(Store<AppState>);
  private router = inject(Router);

  telaVisibility = toSignal(this.store.select(selectTelaVisibility), { initialValue: 'none' as 'none' | 'catalog' | 'all' });
  chatOpen = signal(false);

  showFab = computed(() => {
    const vis = this.telaVisibility();
    if (vis === 'none') return false;
    if (vis === 'all') return true;
    return this.router.url.startsWith('/catalog');
  });

  toggleChat(): void {
    this.chatOpen.update(v => !v);
  }

  closeChat(): void {
    this.chatOpen.set(false);
  }
}
